import React, { Component } from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  callback: PropTypes.func.isRequired,
  searchText: PropTypes.string,
  disabled: PropTypes.bool
};

class SearchBox extends Component {

    constructor (props) {
      super(props);
      /*this.state = {
        'callback': props.callback,
        'searchText': props.searchText ? props.searchText : '',
        'disabled': props.disabled ? props.disabled : false
      };*/
    }

    search(text) {
       /* this.setState({
            'searchText': text
        });*/
        this.props.callback(text);
    }

    render () {
        return (

            <div className="form-label-group icon-wrapper">
                <input disabled={this.props.disabled} 
                    value={this.props.searchText} 
                    onChange={e => this.search(e.target.value)}
                    type="text"
                    id="inputSearch"
                    className="form-control search-input my-4"
                    placeholder={ __('app.general.search') } />
                <label htmlFor="inputSearch">{ __('app.general.search') }</label>
                {this.props.searchText !== '' &&
                    <i onClick={() => this.search('') } className="far fa-times clear-search cur-p"></i>
                }
            </div>

        )
    }
}

SearchBox.propTypes = propTypes;

export default SearchBox;